export enum NetworkAssemblyFilterOptions {
    TS = 'Transmission Stations',
    SS = 'Injection Substations',
    DT = 'Distribution Substations'
}